import React from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { ClipboardList, LogOut, Snowflake, ChevronLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function TechLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const canBack = location.pathname !== "/tech";

  return (
    <div className="min-h-screen bg-[#F5F6FA] flex flex-col max-w-lg mx-auto">
      {/* Header */}
      <header className="bg-[#181854] text-white sticky top-0 z-10 shadow-md">
        <div className="px-4 py-3 flex items-center gap-3">
          {canBack ? (
            <button
              onClick={() => navigate(-1)}
              data-testid="tech-back-btn"
              aria-label="Back"
              className="w-11 h-11 min-w-[44px] min-h-[44px] rounded-lg flex items-center justify-center hover:bg-[#101038] transition-colors duration-200"
            >
              <ChevronLeft size={26} strokeWidth={2.2} />
            </button>
          ) : (
            <div className="bg-white rounded-lg px-2 py-1.5 flex items-center justify-center shadow-sm">
              <img
                src="/brand/gt-logo.webp"
                alt="GT Refrigeration & Aircon Services"
                className="h-7 w-auto object-contain"
                data-testid="tech-header-logo"
                style={{ maxWidth: "120px" }}
              />
            </div>
          )}
          <div className="flex-1 leading-tight">
            <div className="text-white font-semibold">GT Field OS</div>
            <div className="text-white/70 text-xs flex items-center gap-1.5">
              <Snowflake size={11} strokeWidth={2.4} />
              {user?.name}
            </div>
          </div>
          <button
            onClick={logout}
            data-testid="tech-logout-btn"
            className="w-10 h-10 rounded-lg flex items-center justify-center hover:bg-[#101038] transition-colors duration-200"
            aria-label="Log out"
          >
            <LogOut size={20} />
          </button>
        </div>
      </header>

      <main className="flex-1 pb-20">
        <Outlet />
      </main>

      {/* Bottom Nav */}
      <nav className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto bg-white border-t border-[#E4E6EF] z-20">
        <NavLink
          to="/tech"
          end
          data-testid="tech-nav-my-jobs"
          className={({ isActive }) =>
            `flex items-center justify-center gap-2 py-4 text-sm font-semibold transition-colors duration-200 ${
              isActive ? "text-[#181854]" : "text-[#6A6E85]"
            }`
          }
        >
          <ClipboardList size={20} />
          My Jobs Today
        </NavLink>
      </nav>
    </div>
  );
}
